/*
 * サブシステム名：マスタ管理
 * 機能名：人員マスタ一覧
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdTextBox = () => import('@/components/DdTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')

export default {
  name: 'MstJininList',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      jininCd: '',
      jininNmSei: '',
      jininNmKanaSei: '',
      eigyoshoCd: '',
      jomuFlg: 'False'
    },
    headersEigyoshoList: header.mstEigyoshoHeaders,
    modeKengen: 0
  }),
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdTextBox,
    DdCheckbox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.seinengappiDisp = elem.seinengappi ? filter.dateFormatter(elem.seinengappi) : ''
        elem.jininNmSeiMei = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.jininNmKanaSeiMei = elem.jininNmKanaSei + (elem.jininNmKanaMei ? ' ' + elem.jininNmKanaMei : '')
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstJininList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '人員コード', value: 'jininCd' },
              { text: '人員氏名', value: 'jininNmSeiMei' },
              { text: '人員氏名カナ', value: 'jininNmKanaSeiMei' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '乗務員フラグ', value: 'jomuFlgNm', align: 'center' },
              // { text: '乗務員種別', value: 'jomuSbtNm' },
              // { text: '人員略称', value: 'jininAbbr' },
              { text: '性別', value: 'seibetsuKbnNm' },
              // { text: '血液型', value: 'ketsuekigataKbnNm' },
              // { text: '生年月日', value: 'seinengappiDisp', align: 'center' },
              // { text: '郵便番号', value: 'yubinNo' },
              // { text: '住所', value: 'jusho' },
              // { text: '電話番号', value: 'telNo' },
              // { text: '携帯番号', value: 'keitaiTelNo' },
              // { text: 'メールアドレス', value: 'mailAddress' },
              // { text: '職種', value: 'shokushuSbtNm' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              jininCd: '',
              jininNmSei: '',
              jininNmKanaSei: '',
              eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              jomuFlg: 'False'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstJininList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          var jomuFlgBool = c.jomuFlg === 'true'
          self.conditions.jomuFlg = jomuFlgBool
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstJininList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstJininList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstJininList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstJininList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstJinin/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            jomuFlg: self.conditions.jomuFlg
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              jininCd: '',
              jininNmSei: '',
              jininNmKanaSei: '',
              eigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : '',
              jomuFlg: 'False'
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1

            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
